import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import { Box, Button, Alert, Snackbar } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, get } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import SectionHeading from "../../GRI300/GRI308/SectionHeading";
import CustomTextField from "../../GRI300/GRI308/CustomTextField";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI404_2 = ({ hide }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [formData, setFormData] = useState({
    skillEnhancementInitiatives: "",
    careerTransitionPrograms: "",
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/gri/get?type=GRI400&Id=${id}`);
        if (response?.data?.data?.year < currentYear - 1)
          setDisabled(true);
        const data = response.data.data.GRI400?.skillDevelopmentPrograms || {};
        setFormData({
          skillEnhancementInitiatives: data.skillEnhancementInitiatives || "",
          careerTransitionPrograms: data.careerTransitionPrograms || "",
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const handleStorage = () => {
      setGriReview(JSON.parse(localStorage.getItem("griReview")));
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const validateForm = () => {
    let newErrors = {};
    let formIsValid = true;

    if (!formData.skillEnhancementInitiatives) {
      newErrors.skillEnhancementInitiatives = "This field is required";
      formIsValid = false;
    }

    if (!formData.careerTransitionPrograms) {
      newErrors.careerTransitionPrograms = "This field is required";
      formIsValid = false;
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // if (!validateForm()) return;
      const payload = {
        type: "GRI400",
        submitted404_2: true,
        skillDevelopmentPrograms: {
          ...formData,
        },
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, payload);
        navigate(`/gri/gri400/404-3/${id}`);
      } catch (error) {
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri400/404-3/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      {!hide && (
        <p className={styles.section_heading}>404 : Training and Education</p>
      )}
      <p
        className={styles.main_heading}
        style={{ marginBottom: hide ? "-1rem" : "0" }}
      >
        404-2 : Programs for upgrading employee skills and transition assistance
        programs
      </p>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <SectionHeading text="a. Describe the programs implemented and the support provided to enhance employee skills? Please specify the type and scope of these programs." />
        <CustomTextField
          value={formData.skillEnhancementInitiatives}
          onChange={(e) =>
            handleInputChange("skillEnhancementInitiatives", e.target.value)
          }
          error={errors.skillEnhancementInitiatives}
          helperText={errors.skillEnhancementInitiatives}
          disabled={disabled}
        />

        <SectionHeading text="b. Outline the transition assistance programs offered to support ongoing employability and manage career transitions resulting from retirement or termination of employment?" />
        <CustomTextField
          value={formData.careerTransitionPrograms}
          onChange={(e) =>
            handleInputChange("careerTransitionPrograms", e.target.value)
          }
          error={errors.careerTransitionPrograms}
          helperText={errors.careerTransitionPrograms}
          disabled={disabled}
        />

        {/* Submit Button */}

        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI404_2;
